document.addEventListener("DOMContentLoaded", function () {
  const credits = document.querySelector("#credits");
  if (!credits) return;

  document
    .querySelectorAll<HTMLElement>("a[data-media-id]")
    .forEach(function (link) {
      link.addEventListener("click", function () {
        const id = link.getAttribute("data-media-id");

        credits.querySelectorAll("details").forEach(function (details) {
          details.removeAttribute("open");
        });

        credits
          .querySelector(`.block__item[data-id="${id}"] details`)
          ?.setAttribute("open", "true");
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector("#back-to-top");
  const toggle = function () {
    btn?.classList.toggle("visible", window.scrollY > window.innerHeight);
  };
  window.addEventListener("scroll", toggle);
  toggle();
});
